import { IDotXetChungChiPhamViActionTypes } from "../../action-types/xet-chung-chi/IDotXetChungChiPhamViActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IDotXetChungChiPhamViReducer } from "../../reducer-model/xet-chung-chi/IDotXetChungChiPhamViReducer";

const iniState: IDotXetChungChiPhamViReducer = {
    status: eReducerStatusBase.is_not_initialization,
    dotXetChungChiPhamVi: [],
    isShowAddModal: false,
    dotXetChungChiPhamViEdit: undefined,
}

export const dotXetChungChiPhamViReducer = (state: IDotXetChungChiPhamViReducer = iniState, action: IDotXetChungChiPhamViActionTypes): IDotXetChungChiPhamViReducer => {
    switch (action.type) {
        case "DOT_XET_CHUNG_CHI_PHAM_VI_LOAD_BY_DOT_XET_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            };
        case "DOT_XET_CHUNG_CHI_PHAM_VI_LOAD_BY_DOT_XET_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                dotXetChungChiPhamVi: action.payload
            };
        case "DOT_XET_CHUNG_CHI_PHAM_VI_LOAD_BY_DOT_XET_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            };
        case "DOT_XET_CHUNG_CHI_PHAM_VI_ADD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "DOT_XET_CHUNG_CHI_PHAM_VI_ADD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                isShowAddModal: false,
            };
        case "DOT_XET_CHUNG_CHI_PHAM_VI_ADD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "DOT_XET_CHUNG_CHI_PHAM_VI_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting,
            };
        case "DOT_XET_CHUNG_CHI_PHAM_VI_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "DOT_XET_CHUNG_CHI_PHAM_VI_SHOW_ADD_MODAL":
            return {
                ...state,
                isShowAddModal: true,
            };
        case "DOT_XET_CHUNG_CHI_PHAM_VI_CLOSE_ADD_MODAL":
            return {
                ...state,
                isShowAddModal: false,
            };
        default:
            return state;
    }
}